<div class="row">
    <div class="col-sm-11">
      <h5 class="modal-title">{{ passedData.title | translate }}</h5>
    </div>
    <div class="col-sm-1">
      <div class="modal-actions">
        <div class="modal-close">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
        </div>
      </div>
    </div>
  </div>
  <form [formGroup]="form" class="form-content">
    <div class="section-wrapper">
      <div class="form-layout">
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.FIRST-NAME' | translate}}</label>
                    <input class="form-control" name="FirstName" formControlName="FirstName" >
                </div>
            </div>
        </div>
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.LAST-NAME' | translate}}</label>
                    <input class="form-control" name="LastName" formControlName="LastName" >
                </div>
            </div>
        </div>
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.DATE-OF-BIRTH' | translate}}</label>
                    <input class="form-control" datepicker [beforeToday]="true" formControlName="DateOfBirth">
                </div>
            </div>
        </div>
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.NATIONALITY' | translate}}</label>
                    <ng-select [items]="countries" bindLabel="Name" bindValue="Id" formControlName="CountryId"
                      placeholder="{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.NATIONALITY-PLACEHOLDER' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
                      <!-- Selected item -->
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.Iso2 ? (('COUNTRY.'+item.Iso2) | translate) : ""}}
                      </ng-template>
                      <!-- Dropdown items -->
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        {{('COUNTRY.'+item.Iso2) | translate}}
                      </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.DOCUMENTTYPE' | translate}}</label>
                    <input class="form-control" name="DocumentType" formControlName="DocumentType" >
                </div>
            </div>
        </div>
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.REASON' | translate}}</label>
                    <ng-select [items]="identificationReasons" bindLabel="Reason" bindValue="Id" formControlName="IdentificationStatusReasonId" placeholder="{{'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.REASON-PLACEHOLDER' | translate}}"
                       [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
                </div>
            </div>
        </div>
        <div class="row mg-b-25"> 
            <div class="col-lg-12">
                <div class="form-group">
                    <label class="form-control-label">{{ 'CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.EXPIRATION-DATE' | translate}}</label>
                    <input class="form-control" datepicker [beforeToday]="false" formControlName="ExpirationDate">
                </div>
            </div>
        </div>
        <div class="form-layout-footer row">
          <div class="col-6">
            <button [disabled]="form.invalid" (click)="submit()" class="btn btn-block btn-primary bd-0"><i class="far fa-save"></i>
            <span>{{'GENERIC.BUTTON.SAVE' | translate }}</span></button>
          </div>
          <div class="col-6">
            <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0"><i class="fas fa-ban"></i>
            <span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
          </div>
        </div>
  
      </div>
    </div>
  </form>